import { Link, useOutletContext } from "react-router-dom";
import { Home, ArrowLeft, Search } from "lucide-react";
import { Button } from "@/components/ui/button";

function NotFound() {
  const context = useOutletContext();
  const isDark = context?.isDark ?? true;

  return (
    <div className="min-h-screen flex items-center justify-center py-12">
      <div className="max-w-lg mx-auto px-4 text-center">
        {/* 404 Number */}
        <h1 className={`text-[8rem] md:text-[10rem] font-black font-['Chivo'] leading-none ${isDark ? 'text-white/10' : 'text-slate-200'}`}>
          404
        </h1>

        {/* Message */}
        <div className="-mt-10 relative z-10">
          <h2 className={`text-2xl md:text-3xl font-bold font-['Chivo'] mb-4 ${isDark ? 'text-white' : 'text-slate-900'}`}>
            Pagina niet gevonden
          </h2>
          <p className={`mb-8 ${isDark ? 'text-slate-400' : 'text-slate-600'}`}>
            De pagina die je zoekt bestaat niet of is verplaatst. Controleer de URL of ga terug naar de homepagina.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild className="bg-[hsl(48,96%,53%)] hover:bg-[hsl(48,96%,43%)] text-black font-semibold">
              <Link to="/">
                <Home className="h-4 w-4 mr-2" />
                Naar homepagina
              </Link>
            </Button>
            <Button asChild variant="outline" className={isDark ? 'border-white/20 text-white hover:bg-white/10' : ''}>
              <Link to="/contact">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Contacteer ons
              </Link>
            </Button>
          </div>
        </div>

        {/* Decorative Element */}
        <div className="mt-12 flex justify-center">
          <Search className={`h-16 w-16 ${isDark ? 'text-white/5' : 'text-slate-100'}`} />
        </div>
      </div>
    </div>
  );
}

export default NotFound;
